import IMask from 'imask';
import { useEffect, useCallback, useRef } from 'react';
export function useIMask(opts, { onAccept, onComplete, }) {
    const ref = useRef(null);
    const maskRef = useRef(null);
    const deleteMask = useCallback(() => {
        var _a;
        (_a = maskRef.current) === null || _a === void 0 ? void 0 : _a.destroy();
        maskRef.current = null;
    }, []);
    const handleOnAccept = useCallback((event) => maskRef.current && (onAccept === null || onAccept === void 0 ? void 0 : onAccept(maskRef.current.value, maskRef.current, event)), [onAccept]);
    const handleOnComplete = useCallback(() => maskRef.current && (onComplete === null || onComplete === void 0 ? void 0 : onComplete(maskRef.current.value, maskRef.current)), [onComplete]);
    useEffect(() => {
        const el = ref.current;
        if (!el || !(opts === null || opts === void 0 ? void 0 : opts.mask)) {
            return deleteMask();
        }
        const mask = maskRef.current;
        if (!mask && el && (opts === null || opts === void 0 ? void 0 : opts.mask)) {
            maskRef.current = IMask(el, opts);
            if (el.value !== maskRef.current.value) {
                handleOnAccept();
            }
        }
        else {
            mask === null || mask === void 0 ? void 0 : mask.updateOptions(opts);
        }
    }, [opts, deleteMask, handleOnAccept]);
    useEffect(() => {
        if (!maskRef.current) {
            return;
        }
        const mask = maskRef.current;
        mask.on('accept', handleOnAccept);
        mask.on('complete', handleOnComplete);
        return () => {
            mask.off('accept', handleOnAccept);
            mask.off('complete', handleOnComplete);
        };
    }, [handleOnAccept, handleOnComplete]);
    useEffect(() => deleteMask, [deleteMask]);
    return {
        ref,
        maskRef,
    };
}
//# sourceMappingURL=imask.js.map